import { Button } from "@/components/ui/button";
import { Search } from "lucide-react";

const MAX_VISIBLE_QUOTES = 2;

interface DiagnosisSourceTextProps {
  code: string;
  quotes: string[];
  isFocused: boolean;
  onToggleHighlight: () => void;
}

export const DiagnosisSourceText = ({ code, quotes, isFocused, onToggleHighlight }: DiagnosisSourceTextProps) => {
  if (quotes.length === 0) return null;

  const hiddenCount = quotes.length - MAX_VISIBLE_QUOTES;

  return (
    <div className="mt-1 flex items-start gap-1" data-testid="diagnosis-source-text">
      <Button
        size="sm"
        variant="ghost"
        className={`h-5 w-5 shrink-0 p-0 ${isFocused ? "text-sky-500" : "text-gray-400 hover:text-gray-600"}`}
        onClick={(e) => {
          e.stopPropagation();
          onToggleHighlight();
        }}
        aria-label={`Highlight evidence for ${code}`}
      >
        <Search className="h-3 w-3" />
      </Button>
      <div className="min-w-0 space-y-0.5 text-xs italic text-gray-400">
        {quotes.slice(0, MAX_VISIBLE_QUOTES).map((quote) => (
          <div key={quote} className="line-clamp-2" title={quote}>
            “{quote}”
          </div>
        ))}
        {hiddenCount > 0 && <div>+{hiddenCount} more</div>}
      </div>
    </div>
  );
};
